export enum ANALYZERS {
    ATTACHMENTS = "AttachmentsAnalyzer",
    CORRESPONDENCE = "CorrespondenceAnalyzer",
    DESIGNATIONS = "DesignationsAnalyzer",
    DOMAIN_AGE = "DomainAgeAnalyzer",
    LINKS = "LinksAnalyzer",
    PUBLIC_EMAIL = "PublicEmailAnalyzer",
    REPLY_TO = "ReplyToAnalyzer",
    NO_REPLY_SENDER = "NoReplyAnalyzer",
    SOURCE = "SourceAnalyzer"
}

export enum HEADERS {
    RETURN_PATH = "Return-Path",
    REPLY_TO = "Reply-To",
    FROM = "From",
    DKIM_SIGNATURE = "DKIM-Signature",
    RECEIVED_SPF = "Received-SPF",
    AUTHENTICATION_RESULTS = "Authentication-Results",
}

export enum HEADERS_KEYS {
    X_FORWARDED_FOR = "x-forwarded-for",
    FORWARDED = "forwarded",
    RECEIVED = "received",
    WITH_ESMTP_ID = "with esmtp id",
    DMARC_PASS = "dmarc=pass",
    DKIM_PASS = "dkim=pass",
    DMARC = "dmarc",
    DKIM = "dkim",
    COMP_AUTH = "compauth",
    ACTION = "action=",
    ACTION_NONE = "action=none",
    ACTION_REJECT = "action=reject",
    P = "p=",
    P_NONE = "p=none",
    P_REJECT = "p=reject",
    PASS = "Pass",
    SPF = "spf",
    DKIM_SIGNATURE_D = "d",
    SPF_PASS = "spf=pass",
    HEADER_D = "header.d",
    SMTP_MAIL_FROM = "smtp.mailfrom",
    HEADER_FROM = "header.from",
}

export enum ATTRIBUTES {
    ID = "Id",
    ROLE = "role",
    HEADER_NAME = "HeaderName",
    TOTAL_ITEMS_IN_VIEW = "TotalItemsInView"
}

export const enum TAGS {
    TAG = "tag",
    STYLE = "style",
    IMAGE = "img",
    LINK = "a",
    FOLDER = "Folder",
    T_FOLDER = "t:Folder",
    FOLDER_ID = "FolderId",
    T_FOLDER_ID = "t:FolderId",
    ROOT_FOLDER = "RootFolder",
    M_ROOT_FOLDER = "m:RootFolder",
    INTERNET_MSG_HEADER = "InternetMessageHeader",
    T_INTERNET_MSG_HEADER = "t:InternetMessageHeader"
}

export enum HOST_NAMES {
    OUTLOOK_ANDROID = "OutlookAndroid",
    OUTLOOK_IOS = "OutlookIOS",
    OUTLOOK_WEB_APP = "OutlookWebApp"
}

export enum DMARC_POLICY {
    NONE = "none",
    REJECT = "reject",
    QUARANTINE = "quarantine"
}

export enum IMPERSONATION_RISK_VALUES {
    NONE = "none",
    PASS = "pass",
    BEST_GUESS_PASS = "bestguesspass",
    FAIL = "fail",
    SOFT_FAIL = "softfail",
    NEUTRAL = "neutral",
    TEMP_ERROR = "temperror",
    PERM_ERROR = "permerror",
    SOFT_PASS = "softpass",

}

export const DESIGNATION_SERVICE_URL = "DesignationServiceUrl";

export enum RESULT_STATUS {
    SUCCEEDED = "succeeded"
}

export enum NodeResultDecisions {
    PENDING = "pending",
    OLD = "old",
    NEW = "new",
    TRUE = "true",
    "FALSE" = "false",

}
export const COMP_AUTH_MAPPING: Record<string, { result: string; reasonKey: string }> = {
  [IMPERSONATION_RISK_VALUES.PASS]: {
    result: IMPERSONATION_RISK_VALUES.PASS.toString(),
    reasonKey: "risk_flow.comp_auth_pass",
  },
  [IMPERSONATION_RISK_VALUES.SOFT_PASS]: {
    result: IMPERSONATION_RISK_VALUES.SOFT_PASS.toString(),
    reasonKey: "risk_flow.comp_auth_soft_pass",
  },
  [IMPERSONATION_RISK_VALUES.FAIL]: {
    result: IMPERSONATION_RISK_VALUES.FAIL.toString(),
    reasonKey: "risk_flow.comp_auth_fail",
  },
  [IMPERSONATION_RISK_VALUES.NONE]: {
    result: IMPERSONATION_RISK_VALUES.NONE.toString(),
    reasonKey: "risk_flow.comp_auth_none",
  },
}
export const SPF_MAPPING: Record<string, { result: string; reasonKey: string }> = {
    [IMPERSONATION_RISK_VALUES.PASS]: {
        result: IMPERSONATION_RISK_VALUES.PASS.toString(),
        reasonKey: "risk_flow.spf_pass",
    },
    [IMPERSONATION_RISK_VALUES.SOFT_FAIL]: {
        result: IMPERSONATION_RISK_VALUES.SOFT_FAIL.toString(),
        reasonKey: "risk_flow.spf_soft_fail",
    },
    [IMPERSONATION_RISK_VALUES.NEUTRAL]: {
        result: IMPERSONATION_RISK_VALUES.NEUTRAL.toString(),
        reasonKey: "risk_flow.spf_neutral",
    },
    [IMPERSONATION_RISK_VALUES.NONE]: {
        result: IMPERSONATION_RISK_VALUES.NONE.toString(),
        reasonKey: "risk_flow.spf_none",
    },
    [IMPERSONATION_RISK_VALUES.PERM_ERROR]: {
        result: IMPERSONATION_RISK_VALUES.PERM_ERROR.toString(),
        reasonKey: "risk_flow.spf_perm_error",
    },
    [IMPERSONATION_RISK_VALUES.TEMP_ERROR]: {
        result: IMPERSONATION_RISK_VALUES.TEMP_ERROR.toString(),
        reasonKey: "risk_flow.spf_temp_error",
    },
    [IMPERSONATION_RISK_VALUES.FAIL]:{
        result: IMPERSONATION_RISK_VALUES.FAIL.toString(),
        reasonKey: "risk_flow.spf_failed",
    }
};

export const DKIM_MAPPING: Record<string, { result: string; reasonKey: string }> = {
    [IMPERSONATION_RISK_VALUES.PASS]: {
        result: IMPERSONATION_RISK_VALUES.PASS.toString(),
        reasonKey: "risk_flow.dkim_enabled",
    },
    [IMPERSONATION_RISK_VALUES.NONE]: {
        result: IMPERSONATION_RISK_VALUES.NONE.toString(),
        reasonKey: "risk_flow.dkim_none",
    },
    [IMPERSONATION_RISK_VALUES.FAIL]:{
        result: IMPERSONATION_RISK_VALUES.FAIL.toString(),
        reasonKey: "risk_flow.dkim_failed",
    }
};

export const DMARC_MAPPING: Record<string, { result: string; reasonKey: string }> = {
    [IMPERSONATION_RISK_VALUES.PASS]: {
        result: IMPERSONATION_RISK_VALUES.PASS.toString(),
        reasonKey: "risk_flow.check_dmarc_passed",
    },[IMPERSONATION_RISK_VALUES.BEST_GUESS_PASS]: {
        result: IMPERSONATION_RISK_VALUES.PASS.toString(),
        reasonKey: "risk_flow.check_dmarc_passed",
    },
    [IMPERSONATION_RISK_VALUES.NONE]: {
        result: IMPERSONATION_RISK_VALUES.NONE.toString(),
        reasonKey: "risk_flow.dmarc_none",
    },
    [IMPERSONATION_RISK_VALUES.FAIL]:{
        result: IMPERSONATION_RISK_VALUES.FAIL.toString(),
        reasonKey: "risk_flow.check_dmarc_failed",
    }
};

export const IMAGE_EXTENSIONS = ["jpg", "jpeg", "png"];

export enum DOMAIN_CONFIG_KEYS {
    SPF = 'SPF',
    DMARC = 'DMARC',
    DKIM = 'DKIM',
}

export enum DOMAIN_CONFIG_TO_FLOW_STEP {
    SPF = "isSPFConfigured",
    DMARC = "checkDMARCConfiguration",
    DKIM = "isDKIMEnabled"
}
export enum DOMAIN_CONFIG_VALUES {
    SETUP = "setup",
    NOT_SETUP = "notSetup"
}

export enum DOMAIN_CONFIG_TO_RESULT_INFO {
    SPF = 'domainSpfSetup',
    DMARC = 'domainDmarcSetup',
    DKIM = 'domainDkimSetup',
}

export enum DOMAIN_ORIGIN_CONDITION_VALUES {
    MATCH = "match",
    DOESNT_MATCH = "doesntMatch",
    NOT_PROVIDED = "notProvided"
}
